import { useNavigationContext } from '../../../contexts/NavigationContext';
import EventPage from './Events/EventPage';
import NewsPage from './News/NewsPage';
import MenuPage from './Menu/MenuPage';
import './BasseCour.scss';
import MainLayout from '../../../components/Display/MainLayout';

function Home() {
  const { navigationContext } = useNavigationContext();

  return (
    <MainLayout enableAnalytics={false} scope={'bassecour'} websiteLabel={"labassecour.org"}>
      <EventPage isActive={navigationContext.activeAppKey === 'bacevent'} />
      <NewsPage isActive={navigationContext.activeAppKey === 'bacnews'} />
      <MenuPage isActive={navigationContext.activeAppKey === 'bacmenu'} />
    </MainLayout>
  );
}

export default Home;
